import React, { useEffect, useState } from "react";
import { Form, Input, Select, Space, DatePicker } from 'antd';
import FormItem from "components/fields/FormItem";
import { connect, useSelector } from "react-redux";
import { 
	getLeaveDetails, 
	doLeaveCreate, 
	doLeaveUpdate 
} from "../../../../redux/leave/leaveState";
import CrudButtons from "components/button/crudbuttons";
import { DATE_FORMAT, MODULE_LEAVE } from "variables/constants";
import dayjs from "dayjs";
import { requiredField } from "utils/crudSagaHelper";
import { getLabel } from "utils";
import SwitchField from "components/fields/SwitchField";
import LeaveSummaryCard from "./LeaveSummaryCard";

const LeaveForm = ({
	getRecord, 
	doCreate, 
	doUpdate, 
	recordData, 
	requesting, 
	success, 
	onCancel,
	submitLabel,
	...props
}) => {
	
  	const { recordId, mode } = props;  	
  	const [form] = Form.useForm();
	const authUser = useSelector((state) => state.auth.user);
	const { RangePicker } = DatePicker;
	const [formData, setFormData] = useState({
			lve_user_id: null,
			lve_date_range: [],
		});
  	
  	useEffect(() => {
        getRecord(recordId);
	}, [getRecord, recordId]);
	
	useEffect(() => {
		if(recordData){
			form.resetFields();
			const { user:user, ...rest } = recordData;

			const initialValues = {
				...rest,
				...user?.userDetail,
				lve_user_id: recordData?.lve_user_id ?? null,
				lve_date_range: recordData?.lve_date_from && recordData?.lve_date_to
					? [dayjs(recordData.lve_date_from), dayjs(recordData.lve_date_to)]
					: [],
				user_details: {
					ude_first_name: user?.user_detail?.ude_first_name ?? "",
					ude_last_name: user?.user_detail?.ude_last_name ?? "",
				},
			};	
	        form.setFieldsValue(initialValues);

			console.log("initialValues:", initialValues);
        }
		
    }, [recordData, form]);
    
  	const onSubmit = (formData) => {	
    	try {  
			if (formData.lve_date_range?.length === 2) {
				formData.lve_date_from = formData.lve_date_range[0].format(`${DATE_FORMAT}`);
				formData.lve_date_to = formData.lve_date_range[1].format(`${DATE_FORMAT}`);
			}
			delete formData.lve_date_range;

			if (!formData.lve_user_id) {
				formData.lve_user_id = authUser?.id;
			}
			recordData.lve_id > 0 ? doUpdate(formData): doCreate(formData); 
    	} catch (error) {
      		console.error('Save failed:', error);
    	}
  	};
  
  	return (
		
    	<Form form={form}
			className={mode !== "view" ? "form" : ""}
			layout="vertical"
			onFinish={onSubmit}
		>   
			<FormItem
				name="lve_id"
				hidden
			>
				<Input type="hidden"/>
			</FormItem>
		<div className="flex grid grid-cols-1 md:grid-cols-3 gap-3 mb-6">
			<LeaveSummaryCard leaveType="Vacation" leaveAmount={7} remainingLeave={15} />
			<LeaveSummaryCard leaveType="Sick" leaveAmount={7} remainingLeave={10} />
			<LeaveSummaryCard leaveType="Personal" leaveAmount={3} remainingLeave={5} />
		</div>

			<div className="grid grid-cols-3 gap-y-2 gap-x-4">         		            	            
				{authUser?.user_level === 1 && mode !== "view" && (
					<FormItem
						className="font-medium mb-2"
						label="Employee"
						required
					>
						<FormItem
							name="lve_user_id"
							noStyle
							rules={[requiredField]}
							initialValue={formData?.lve_user_id || recordData?.lve_user_id || null}
						>
							<Select
								showSearch
								allowClear
								className="input-field"
								placeholder="Select Employee"
								onChange={(value) =>
									setFormData((prev) => ({ ...prev, ots_user_id: value }))
								}
								value={formData?.ots_user_id ?? recordData?.ots_user_id ?? undefined}
								options={recordData?.employeeList?.map((emp) => {
									const [, empName] = emp.label.split(" - ");
									return { value: emp.value, label: empName };
								})}
								optionFilterProp="label"
							/>
						</FormItem>
					</FormItem>
				)}  
				
				<FormItem className="font-medium mb-2"
					name="lve_type_id" 
					label="Type"
					rules={[requiredField]}
				>
					{mode !== "view" ? 
						<Select id="lve_type_id"
							allowClear={true}
							showSearch
							className="input-field"
							options={recordData?.leaveTypeList}
						/>
						: 
						<label className="text-base label-value dark:text-white">
							{getLabel(recordData?.leaveTypeList, recordData?.lve_type_id)}
						</label>
					}
				</FormItem>
				
				<FormItem
					className="font-medium mb-2"
					name="lve_date_range" 
					label="Date"
					rules={[requiredField]}
				>
					{mode !== "view" ? (
						<RangePicker
							className="input-field w-full"
							format={DATE_FORMAT}
						/>
					) : (
						<label className="text-base label-value dark:text-white">
							{recordData?.ots_date_from && recordData?.ots_date_to
								? `${dayjs(recordData.ots_date_from).format(
									{DATE_FORMAT}
								)} - ${dayjs(recordData.ots_date_to).format(
									{DATE_FORMAT}
								)}`
							: ""}
						</label>
					)}
				</FormItem>

				

				<FormItem className="font-medium mb-2"
					name="lve_status_id" 
					label="Status"
					rules={[requiredField]}
				>
					{mode !== "view" ? 
						<Select id="lve_status_id"
							allowClear={true}
							showSearch
							className="input-field"
							options={recordData?.leaveStatusList}
						/>
						: 
						<label className="text-base label-value dark:text-white">
							{getLabel(recordData?.leaveStatusList, recordData?.lve_status_id)}
						</label>
					}
				</FormItem>

				<FormItem className="font-medium mb-2"
					label="Is Unpaid"
					name="lve_is_unpaid"
					
				>
					<SwitchField
						id="lve_is_unpaid"
						mode="edit"
						type="text"
						labelYes="Yes"
						labelNo="No"
					/>
				</FormItem>
			</div>
			<div>
				{(mode === "edit") && (
					<CrudButtons 
						mode={mode} 
						recordId={recordData?.lve_id ?? 0} 
						isModal={true}
						modalId={recordData?.lve_id > 0 ? 'edit_leave' : 'add_leave'}
						cancelLabel="Cancel"
						doHideModal={onCancel}
						submitLabel={submitLabel}
						moduleId={MODULE_LEAVE}
					/>
				)}
			</div> 				 			
		</Form>	 	
  	);
};

const mapStateToProps = (state) => ({
  	recordData: state.leave.leaveDetails?.data,
  	requesting: state.leave.leaveDetails?.requesting,
  	success: state.leave.leaveDetails?.succcess,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getLeaveDetails(id)),
  	doCreate: (data) => dispatch(doLeaveCreate(data)),
  	doUpdate: (data) => dispatch(doLeaveUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LeaveForm);
